import { useGraphqlQuery } from "@mzara/component";
import { FormationCategoryListQuery } from "../queries/FormationCategoryQuery";

export const useFormationCategoryQuery = () => {
    return useGraphqlQuery<FormationCategoryListQuery, any>(
        new FormationCategoryListQuery({ data: { tp: "FORMATION_CATEGORY" } }),
        { suspense: true }
    );
};
